export default IconDeviceUsb => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-device-usb" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M8 8h8v9a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-9z" />
  <path d="M10 8v-4h4v4" />
</svg>`;